var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloseGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85356 0.853552C9.04882 0.658289 9.04882 0.341707 8.85356 0.146445C8.6583 -0.0488174 8.34172 -0.0488175 8.14645 0.146445L4.50001 3.79289L0.853561 0.146445C0.658299 -0.0488175 0.341716 -0.0488175 0.146454 0.146445C-0.0488079 0.341707 -0.0488079 0.658289 0.146454 0.853552L3.7929 4.5L0.146454 8.14644C-0.0488084 8.34171 -0.0488085 8.65829 0.146453 8.85355C0.341716 9.04881 0.658299 9.04881 0.853561 8.85355L4.50001 5.20711L8.14645 8.85355C8.34172 9.04881 8.6583 9.04881 8.85356 8.85355C9.04882 8.65829 9.04882 8.34171 8.85356 8.14644L5.20711 4.5L8.85356 0.853552Z",
    fill: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseGray);
export default __webpack_public_path__ + "static/media/icon-close-gray.86aa32a48684a2680f5b4812f804adc0.svg";
export { ForwardRef as ReactComponent };